import validator from "validator";
import message from "../../../../messages/advertise/native";

const validateAddress = (address) => {
  if (validator.isEmpty(address)) {
    return message.ADDRESS_DOSE_NOT_EXIST;
  }

  if (!address.trim().length) {
    return message.ADDRESS_DOSE_NOT_EXIST;
  }

  if (
    !validator.isURL(address, {
      protocols: ["http", "https", "ftp"],
      require_protocol: true,
      require_host: true,
      require_valid_protocol: true,
      allow_trailing_dot: false,
      allow_protocol_relative_urls: false,
    })
  ) {
    return message.ADDRESS_INVALID;
  }

  // if (!validator.isURL(address)) {
  //   return message.ADDRESS_INVALID;
  // }

  return true;
};

const validateTitle = (title) => {
  if (validator.isEmpty(title)) {
    return message.TITLE_DOSE_NOT_EXIST;
  }

  if (!title.trim().length) {
    return message.TITLE_DOSE_NOT_EXIST;
  }

  if (title.length > 70) {
    return message.TITLE_INVALID;
  }

  return true;
};
const validateImageContentCropped = (imageContentCropped) => {
  if (validator.isEmpty(imageContentCropped)) {
    return message.IMAGE_DOSE_NOT_EXIST;
  }

  if (!imageContentCropped.trim().length) {
    return message.IMAGE_INVALID;
  }

  if (
    !imageContentCropped.includes("data:image/") &&
    !imageContentCropped.includes(";base64")
  ) {
    return message.IMAGE_INVALID;
  }
  return true;
};

const validateActive = (active) => {
  if (validator.isEmpty(active)) {
    return message.ACTIVE_NOT_EXIST;
  }

  if (!(active == 1 || active == 0)) {
    return message.ACTIVE_INVALID;
  }

  return true;
};

const validateFormAddAdvertiseNative = (info) => {
  const resValidateAddress = validateAddress(info.address);
  if (resValidateAddress != true) {
    return resValidateAddress;
  }

  const resValidateTitle = validateTitle(info.title);
  if (resValidateTitle != true) {
    return resValidateTitle;
  }

  if (!info.hasOwnProperty("image_content")) {
    return true;
  }

  const resValidateImageContentCropped = validateImageContentCropped(
    info.image_content
  );
  if (resValidateImageContentCropped != true) {
    return resValidateImageContentCropped;
  }

  const resValidateActive = validateActive(info.active);
  if (resValidateActive != true) {
    return resValidateActive;
  }

  return true;
};

export default validateFormAddAdvertiseNative;
